export const removeCoAppData = (data: Record<string, unknown>) => {
  const result = {};

  if (
    data['Frontend/AddCoApplicant'] === false ||
    data['Frontend/AddCoApplicant'] === 'No'
  ) {
    Object.assign(result, getNullifiedCoAppData(data));
  }

  return result;
};

const getNullifiedCoAppData = (data: Record<string, unknown>) => {
  const result = {};

  Object.assign(result, {
    ...Object.keys(data)
      .filter((key) => key.match(/CoApp|CoPerson|CoCustomer/))
      .reduce(
        (acc: Record<string, unknown>, key) => {
          acc[key] = null;
          return acc;
        },
        {
          'LoanApplication/CoApplicantCustomerID': null,
          'LoanApplication/CoApplicantPersonID': null,
          'LoanApplication/CoApplicantMaritalStatus': null,
          'LoanApplication/CoApplicantGrossIncomeYearly': null,
          'LoanApplication/CoApplicantNetIncomeYearly': null,
          'LoanApplication/CoApplicantCitizenship': null,
        }
      ),
  });

  return result;
};
